import { useEffect, useState } from 'react';
import { OutboundCallModalProvider } from '@app/layouts/MainLayout/components/OutboundCall/OutboundCallModal';
import OutboundCallModal from '@app/layouts/MainLayout/components/OutboundCall/OutboundCallModal/OutboundCallModal';
import { OutboundCallDetails } from '@app/layouts/MainLayout/components/OutboundCall/OutboundCallModal/types';
import { TechnicianConfirmationModal } from '@app/layouts/MainLayout/components/OutboundCall/OutboundCallButton/TechnicianConfirmationModal';
import { FeatureErrorBoundary } from '@components/ErrorBoundary';
import { PIP_EVENTS } from '../constants';

/**
 * Always-mounted component that listens for the pip.open.outbound-call event
 * and opens the outbound call modal regardless of what page the user is on.
 */
export function PipOutboundCallTrigger() {
  const [open, setOpen] = useState(false);
  const [technicianDetails, setTechnicianDetails] =
    useState<OutboundCallDetails | null>(null);

  useEffect(() => {
    const handleOpen = () => setOpen(true);
    window.addEventListener(PIP_EVENTS.OPEN_OUTBOUND_CALL, handleOpen);
    return () =>
      window.removeEventListener(PIP_EVENTS.OPEN_OUTBOUND_CALL, handleOpen);
  }, []);

  if (!open && !technicianDetails) return null;

  return (
    <FeatureErrorBoundary featureName='PiP Outbound Call Modal' size='full'>
      <OutboundCallModalProvider>
        <OutboundCallModal
          open={open}
          setOpen={setOpen}
          showTenantSelection
          onTechnicianNext={setTechnicianDetails}
        />
        {technicianDetails && (
          <TechnicianConfirmationModal
            details={technicianDetails}
            onClose={() => setTechnicianDetails(null)}
          />
        )}
      </OutboundCallModalProvider>
    </FeatureErrorBoundary>
  );
}
